import { gql } from '@apollo/client'

export const PRODUCT_FIELDS = gql`
  fragment ProductFields on Product {
    id
    key
    core
    cgm
    patch
    dietitian
    dietitianMenu
    recurring
    addon
    order
    title
    programsName
    details
    includedOptions
    includesCgm
    icon
    description
    callout
    shortDescription
    commitmentMonths
    billingDateChangeable
    requiresShipping
    trialDays
    ownSensor
    url
    interval {
      key
      description
      suffix
      prefix
    }
    price
    productGroup {
      id
      key
      order
      kind
      title
      description
      shortDescription
      details
      interval {
        key
        description
        suffix
      }
    }
    incompatibleAddons {
      id
      key
    }
    eligibleUpgradeProducts {
      id
      key
    }
    appliedPromo {
      code
      providerId
      applicable
      percentOff
      amountOff
    }
    preselected
    pill {
      text
      fill
      size
      type
    }
    insuranceCoverage
    eligibilityListItems
    ehrSchedulingRule {
      appointmentKind
      chargeKind
      count
      key
    }
    showUnitPrice
    units
    metadata
  }
`
